import React, { useState } from "react";
import { getIsDisableAlert, setCurrentStep } from "../dynamicStepper";
import { COMPANY_REG_ROUTE } from "../../../app/router/routes";
import AlertModal from "../../model/AlertModal";

const EndStep = ({ title, focus, status, name, index, route }) => {
	const [alertOpen, setAlertOpen] = useState(false);
	const ACTIVE = status === "ACTIVE" ? true : false;
	const COMPLETED = status === "COMPLETED" ? true : false;
	const RESUBMIT = status === "RESUBMIT" ? true : false;
	const RESUBMITTED = status === "RESUBMITTED" ? true : false;
	const REJECTED = status === "REJECTED" ? true : false;
	const CURRENT = focus;

	const iconSelection = () => {
		if (REJECTED) {
			return "/icons/stepper_icons/delete-sign.png";
		} else {
			if (ACTIVE) {
				return "/icons/stepper_icons/clock--v1.png";
			} else if (COMPLETED) {
				return "/icons/stepper_icons/done.png";
			} else if (RESUBMIT) {
				return "/icons/stepper_icons/resubmit.png";
			} else {
				return "/icons/stepper_icons/lock--v1.png";
			}
		}
	};
	const svgColorSelector = () => {
		if (REJECTED) {
			return "#F5463A";
		} else {
			if (ACTIVE) {
				return "#4c94e7";
			} else if (COMPLETED) {
				return "#20B05E";
			} else if (RESUBMIT) {
				return "#F57C00";
			} else if (RESUBMITTED) {
				return "#F57C00";
			} else {
				return "#dddddd";
			}
		}
	};
	const textColorSelector = () => {
		if (ACTIVE || REJECTED || RESUBMIT || RESUBMITTED) {
			return { color: "#fcfcfc" };
		} else if (COMPLETED) {
			return { color: "#fcfcfc" };
		} else {
			return { color: "#2c2c2c" };
		}
	};
	return (
		<div
			className={
				!(COMPLETED || ACTIVE || REJECTED || RESUBMIT || RESUBMITTED)
					? "cursor-not-allowed"
					: "cursor-pointer"
			}
			style={{ width: "250px" }}
			onClick={() => {
				if (COMPLETED || ACTIVE || REJECTED || RESUBMIT || RESUBMITTED) {
					if (getIsDisableAlert()) {
						setCurrentStep(name, index);
						window.open(route, "_self");
					} else if (!alertOpen) setAlertOpen(true);
				}
			}}>
			<AlertModal
				isOpen={alertOpen}
				setIsOpen={setAlertOpen}
				title={"Warning !"}
				content={"Going back will cause loss of data for the current step!"}
				agree={() => {
					setCurrentStep(name, index);
					window.open(route, "_self");
				}}
			/>
			<svg
				className={
					!(COMPLETED || ACTIVE || REJECTED || RESUBMIT || RESUBMITTED)
						? "cursor-not-allowed"
						: "cursor-pointer"
				}
				width={250}
				height={50}
				viewBox='0 0 250 50'
				xmlns='http://www.w3.org/2000/svg'
				xmlnsXlink='http://www.w3.org/1999/xlink'
				fill={svgColorSelector()}>
				<path className='st0' d='M223.26,45H0l30.31-20L0,5h223.26C258.91,5,258.91,45,223.26,45z' />
			</svg>
			<div
				style={{
					marginTop: "-40px",
					marginLeft: "35px",
					flexDirection: "row",
					display: "flex",
					alignItems: "center",
				}}>
				<span
					style={{
						width: 30,
						height: 30,
						backgroundColor: "#fff",
						borderRadius: "50%",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
					}}>
					<img src={iconSelection()} alt='icon' />
				</span>
				<span className='ml-1 text-sm' style={textColorSelector()}>
					{title}
				</span>
			</div>
			{CURRENT && (
				<div
					style={{
						width: 150,
						height: 15,
						borderStyle: "solid",
						borderWidth: "10px 75px 0 75px",
						borderTopColor: svgColorSelector(),
						borderLeftColor: "transparent",
						borderRightColor: "transparent",
						borderBottomColor: "transparent",
						margin: "10px auto 2px auto",
					}}></div>
			)}
		</div>
	);
};

export default EndStep;
